export default function TrustComparison() {
  return (
    <>
      <section className="relative w-full py-24 md:py-32 bg-white">
        <div className="max-w-[1200px] mx-auto px-6 md:px-10">
          <div className="flex flex-col lg:flex-row gap-16 lg:gap-20">
            <div className="lg:w-[55%]">
              <span className="text-xs tracking-[0.3em] uppercase text-foreground-400 font-label">
                • Почему выбирают нас
              </span>
              <blockquote className="mt-8 font-heading text-2xl md:text-3xl text-foreground-950 leading-[1.5]"
                style={{ fontFamily: 'var(--font-heading)' }}>
                &laquo;Yoybuy Spreadsheet изменил наш подход к закупкам из Китая.
                Больше никаких запутанных форм — просто таблица, в которой всё понятно
                с первого взгляда.&raquo;
              </blockquote>
              <div className="mt-6 flex items-center gap-2">
                <span className="font-label text-sm font-semibold text-foreground-800">
                  Алексей М.
                </span>
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-verified-badge-fill text-primary-500 text-base"></i>
                </div>
                <span className="text-xs text-foreground-400 font-label">Проверенный покупатель</span>
              </div>
            </div>

            <div className="lg:w-[45%]">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20toned%20minimalist%20unboxing%20scene%20with%20neatly%20opened%20shipping%20box%20revealing%20carefully%20wrapped%20fashion%20items%20tissue%20paper%20and%20ribbon%20on%20light%20cream%20surface%20soft%20natural%20window%20lighting%20clean%20editorial%20style%20warm%20beige%20aesthetic%20elegant%20product%20reveal%20composition%20no%20people&width=800&height=1000&seq=yoybuy-trust-v2-01&orientation=portrait"
                alt="Yoybuy упаковка и доставка"
                title="Yoybuy Spreadsheet доставка товаров"
                className="w-full h-auto rounded-lg object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="relative w-full py-24 md:py-32 bg-accent-900">
        <div className="max-w-[1200px] mx-auto px-6 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-16">
            <div className="md:col-span-1">
              <h3 className="text-white font-heading text-xl font-semibold mb-3"
                style={{ fontFamily: 'var(--font-heading)' }}>
                Yoybuy
              </h3>
              <p className="text-white/50 font-label text-xs leading-relaxed">
                Современная система заказа из Китая с максимальной автоматизацией
              </p>
            </div>

            <div className="md:col-span-1">
              <p className="text-white/40 font-label text-xs uppercase tracking-wider mb-3">Возможности</p>
              <div className="relative">
                <input
                  type="text"
                  readOnly
                  value="Сравнить агентов"
                  className="w-full bg-transparent border-b border-white/20 text-white/60 font-label text-sm pb-2 outline-none"
                />
                <div className="absolute right-0 top-0 w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-white/40 text-sm"></i>
                </div>
              </div>
              <p className="text-white/25 font-label text-[10px] mt-1">
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="hover:text-white/40 transition-colors">
                  kaspreadsheet.com
                </a>
              </p>
            </div>

            <div className="md:col-span-1">
              <p className="text-white/40 font-label text-xs uppercase tracking-wider mb-3">Kakobuy</p>
              <div className="space-y-2.5">
                {['Ease of use', 'Automation', 'Beginner friendly'].map((item) => (
                  <p key={item} className="text-white/60 font-label text-sm">{item}</p>
                ))}
              </div>
            </div>

            <div className="md:col-span-1">
              <p className="text-white/40 font-label text-xs uppercase tracking-wider mb-3">Superbuy</p>
              <div className="space-y-2.5">
                {['Ease of use', 'Automation', 'Beginner friendly'].map((item) => (
                  <p key={item} className="text-white/60 font-label text-sm">{item}</p>
                ))}
              </div>
            </div>
          </div>

          <div className="overflow-hidden">
            <div className="text-[clamp(60px,12vw,160px)] font-heading font-extrabold text-accent-800/30 leading-none tracking-tight whitespace-nowrap"
              style={{ fontFamily: 'var(--font-heading)' }}>
              SPREADSHEET
            </div>
          </div>
        </div>
      </section>
    </>
  );
}